import { z } from "zod";

import { constantsData } from "@/data";

export const transformOfflineDataSourceNameFieldFormSchema = z.object({
    dataAction: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
    nameSeparator: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
});
